import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import type { Article, Category } from '@/types/content';

const list = articles as Article[];
const cats = categories as Category[];

const blocks = [
  { cat: cats.find((c) => c.id === 'weekend')!, tone: 'accent' as const },
  { cat: cats.find((c) => c.id === 'holiday')!, tone: 'secondary' as const },
];

export default function ScheduleSection() {
  return (
    <section id="schedule" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Schedule"
          title="档期专区"
          desc="有些内容只属于特定的时间。周末限定在周五到周日上线，假日特辑跟随长假日历更新，到点来看就行。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {blocks.map(({ cat, tone }) => {
            const items = list.filter((a) => a.category === cat.id);
            const isAccent = tone === 'accent';
            return (
              <div
                key={cat.id}
                className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7 flex flex-col"
              >
                <div className="flex items-start justify-between gap-4 mb-5">
                  <div className="flex items-center gap-3">
                    <span
                      className={`w-11 h-11 rounded-lg flex items-center justify-center ${
                        isAccent ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      <i className={`${cat.icon} text-xl`} aria-hidden="true"></i>
                    </span>
                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">{cat.name}</h3>
                      <p className="text-xs text-foreground-500 mt-0.5">{items.length} 篇内容</p>
                    </div>
                  </div>
                  <Link
                    to={`/topics?cat=${cat.id}`}
                    className="text-xs md:text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap transition-colors"
                  >
                    全部
                  </Link>
                </div>
                <p className="text-sm text-foreground-600 leading-7 mb-5">{cat.desc}</p>
                <div className="mt-auto space-y-3">
                  {items.map((a) => (
                    <ArticleCard key={a.id} article={a} variant="horizontal" />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}